import { motion } from 'framer-motion';
import { useGameStore } from '../../store/game.store.js';

export function TicketPreviewCard() {
  const { ticketGrid } = useGameStore();

  return (
    <div className="glass rounded-3xl p-5 border border-white/10 shadow-glow-lg flex flex-col justify-between h-full text-left">
      <div className="space-y-4">
        <div className="flex items-center justify-between">
          <h3 className="font-display text-base font-black tracking-wider text-amber-300 uppercase">
            Your Ticket
          </h3>
          <span className="text-[9px] font-black uppercase tracking-widest text-emerald-400 bg-emerald-950/40 border border-emerald-500/20 px-2 py-0.5 rounded">
            Auto Generated
          </span>
        </div>

        {/* Ticket Box */}
        <div 
          style={{
            background: 'linear-gradient(135deg, rgba(30, 27, 75, 0.4) 0%, rgba(15, 23, 42, 0.6) 100%)',
            boxShadow: 'inset 0 4px 20px rgba(0,0,0,0.5)',
          }}
          className="rounded-2xl p-3 border border-white/5 shadow-2xl relative overflow-hidden"
        >
          {/* Decorative glossy ticket border overlay */}
          <div className="absolute inset-0 rounded-2xl border-2 border-transparent bg-gradient-to-r from-purple-500/10 via-pink-500/10 to-blue-500/10 pointer-events-none -z-10" />

          {/* Grid Layout */}
          <div className="grid grid-rows-3 gap-1.5">
            {ticketGrid.map((row, rIdx) => (
              <div key={rIdx} className="grid grid-cols-9 gap-1.5">
                {row.map((num, cIdx) => {
                  const isBlank = num === 0;

                  return (
                    <motion.div
                      key={cIdx}
                      initial={{ scale: 0.8, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      transition={{ duration: 0.4, delay: (rIdx * 9 + cIdx) * 0.02 }}
                      style={{
                        background: isBlank
                          ? 'transparent'
                          : 'radial-gradient(circle at 35% 35%, #ffffff 0%, #f1f5f9 50%, #cbd5e1 100%)',
                        boxShadow: isBlank ? 'none' : '0 4px 6px rgba(0,0,0,0.3)',
                      }}
                      className={`aspect-square flex items-center justify-center rounded-lg border select-none ${
                        isBlank
                          ? 'border-white/2 bg-slate-950/20'
                          : 'border-slate-300/80 cursor-default'
                      }`}
                    >
                      {!isBlank && (
                        <span className="font-display font-black text-slate-800 text-[10px] md:text-xs">
                          {num}
                        </span>
                      )}
                    </motion.div>
                  );
                })}
              </div>
            ))}
          </div>
        </div>

        {/* Info label */}
        <p className="text-[10px] text-surface-400 leading-normal font-medium text-center">
          In Tambola, tickets contain 3 rows and 9 columns. Numbers are distributed column-wise.
        </p>
      </div>
    </div>
  );
}
